import { Instagram, Link2, Music2, Youtube } from 'lucide-react';
import { SUPPORTED_LINK_IMPORT_PLATFORMS } from '../utils/linkImportPlatforms';
import type { LinkImportProvider } from '../api/linkImports';

const iconTone: Record<LinkImportProvider, string> = {
  youtube: 'bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400',
  tiktok: 'bg-cyan-50 text-slate-950 dark:bg-cyan-500/10 dark:text-cyan-200',
  instagram: 'bg-fuchsia-50 text-fuchsia-600 dark:bg-fuchsia-500/10 dark:text-fuchsia-300',
  facebook: 'bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300',
  x: 'bg-slate-100 text-slate-950 dark:bg-zinc-800 dark:text-zinc-50',
};

function PlatformIcon({ provider }: { provider: LinkImportProvider }) {
  if (provider === 'youtube') return <Youtube className="h-3.5 w-3.5" />;
  if (provider === 'tiktok') return <Music2 className="h-3.5 w-3.5" strokeWidth={2.4} />;
  if (provider === 'instagram') return <Instagram className="h-3.5 w-3.5" />;
  if (provider === 'facebook') return <span className="-mt-px font-bold leading-none">f</span>;
  return <span className="-mt-px text-[13px] font-semibold leading-none">X</span>;
}

export function LinkImportPlatformChips() {
  return (
    <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
      {SUPPORTED_LINK_IMPORT_PLATFORMS.map((platform) => (
        <span
          key={platform.provider}
          className="inline-flex h-8 items-center gap-2 rounded-full border border-indigo-100 bg-white px-3 text-sm font-semibold text-slate-800 shadow-[0_1px_4px_rgba(79,70,229,0.10)] dark:border-indigo-500/20 dark:bg-zinc-900 dark:text-zinc-100"
        >
          <span className={`inline-flex h-5 w-5 items-center justify-center rounded-full text-[12px] ${iconTone[platform.provider]}`}>
            <PlatformIcon provider={platform.provider} />
          </span>
          {platform.label}
        </span>
      ))}
      <span
        className="inline-flex h-8 items-center gap-2 rounded-full border border-slate-200 bg-slate-50/80 px-3 text-sm font-semibold text-slate-500 dark:border-zinc-800 dark:bg-zinc-950 dark:text-zinc-500"
        title="More direct media links will be enabled after provider verification"
      >
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-white text-indigo-500 dark:bg-zinc-900 dark:text-indigo-300">
          <Link2 className="h-3 w-3" />
        </span>
        Many other links
      </span>
    </div>
  );
}
